import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyDy9FwTdqL1A0BhoU6OWHiyCQ_XGCCma-s",
  authDomain: "farmnet-a74d9.firebaseapp.com",
  projectId: "farmnet-a74d9",
  storageBucket: "farmnet-a74d9.firebasestorage.app",
  messagingSenderId: "393546903507",
  appId: "1:393546903507:web:a454500b9a4ab7bcb20926",
  measurementId: "G-B7VBQ9H17Z"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const analytics = getAnalytics(app);

export { app, db, auth, analytics, firebaseConfig };